import { cn } from "@/lib/utils";
import { NewDot } from "./new-dot";

interface YearTabsProps {
  years: number[];
  activeYear: number;
  onChange: (year: number) => void;
  /** 방금 업로드된 보고서가 들어간 연도 — 탭에 점을 찍는다 */
  newYears?: Set<number>;
}

// ============================================
// YearTabs
// 연도별 필터 탭. 선택된 연도는 회색 배경 + 굵은 글씨로 강조.
// ============================================

export const YearTabs = ({
  years,
  activeYear,
  onChange,
  newYears,
}: YearTabsProps) => (
  <div className="flex items-center gap-2">
    {years.map((year) => {
      const isActive = year === activeYear;
      return (
        <button
          key={year}
          type="button"
          onClick={() => onChange(year)}
          // 폰트 스펙은 디자인(text/sm 14px · Pretendard · tracking 0.203px · ss10)을 그대로.
          // weight는 커스텀 타이포 클래스(label-*-medium)가 font-bold를 덮어쓰므로
          // 충돌 없는 tailwind font-medium/bold로 직접 지정한다.
          className={cn(
            "flex h-9 items-center rounded-md px-4 text-sm tracking-[0.203px] text-label-normal transition-colors [font-feature-settings:'ss10'_1]",
            isActive
              ? "bg-background-gray-alternative font-bold shadow-sm"
              : "font-medium hover:bg-neutral-50",
          )}
        >
          {/* 점은 글자 오른쪽 위에 얹는다 — 탭 너비가 흔들리지 않게 흐름 밖으로 뺀다. */}
          <span className="relative">
            {year}년도
            {newYears?.has(year) && (
              <>
                <span className="sr-only">새로 업로드된 보고서 있음</span>
                <NewDot />
              </>
            )}
          </span>
        </button>
      );
    })}
  </div>
);
